import React from "react";
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';

function InsumosGrid({ arrayInsumos, clickDelete, userPermissions }) {

    const formatarValor = (valor) => {
        if (typeof valor !== 'number') {
            valor = parseFloat(valor);
        }
        if (isNaN(valor)) {
            valor = 0;
        }
        return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    };

    if (!arrayInsumos || arrayInsumos.length === 0) {
        return (
            <div className="text-center py-5 text-muted">
                <i className="fas fa-box-open fa-3x mb-3 text-secondary opacity-50"></i>
                <h4 className="fw-light">Nenhum insumo encontrado</h4>
                <p className="mb-0">Não há registros correspondentes à sua pesquisa.</p>
            </div>
        );
    }

    return (
        <div className="insumos-grid-container">
            <div className="table-responsive">
                <table className="table-custom">
                    <thead>
                        <tr>
                            <th className="text-center" style={{ width: '100px' }}>Ações</th>
                            <th className="text-start" style={{ width: '80px' }}>Código</th>
                            <th className="text-start">Descrição</th>
                            <th className="text-start" style={{ width: '150px' }}>Marca</th>
                            <th className="text-start">Fornecedor</th>
                            <th className="text-end" style={{ width: '120px' }}>Vl. Compra</th>
                            <th className="text-center" style={{ width: '100px' }}>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {arrayInsumos.map((insumo) => (
                            <tr key={insumo.id}>
                                <td className="text-center" data-label="Ações">
                                    <div className="actions-cell">
                                        <Link
                                            to={`/app/editarinsumo/${insumo.id}`}
                                            className="btn-action-sm btn-edit"
                                            title="Editar"
                                            onClick={(e) => {
                                                // Validation for Edit
                                                if (userPermissions && userPermissions['editar_insumos'] === false) {
                                                    e.preventDefault();
                                                    Swal.fire({
                                                        icon: 'error',
                                                        title: 'Acesso Negado',
                                                        text: 'Este usuário não possui permissão de edição. Por favor, contate o administrador.',
                                                        confirmButtonColor: '#2185c6'
                                                    });
                                                }
                                            }}
                                        >
                                            <i className="fas fa-pencil-alt"></i>
                                        </Link>
                                        <button onClick={() => clickDelete(insumo.id)} className="btn-action-sm btn-delete" title="Excluir">
                                            <i className="fas fa-trash-alt"></i>
                                        </button>
                                    </div>
                                </td>
                                <td className="fw-bold text-secondary" data-label="Código">{insumo.codigo}</td>
                                <td data-label="Descrição">{insumo.descricao}</td>
                                <td className="text-muted" data-label="Marca">{insumo.marca_descricao || '-'}</td>
                                <td className="text-muted small" data-label="Fornecedor">{insumo.fornecedor_nome || '-'}</td>
                                <td className="text-end font-monospace" data-label="Vl. Compra">{formatarValor(insumo.valor_compra)}</td>
                                <td className="text-center" data-label="Status">
                                    <span className={`status-badge-custom ${insumo.status === 'Ativo' ? 'status-ativo' : 'status-inativo'}`}>
                                        {insumo.status}
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default InsumosGrid;